import { HandbookEditView } from './views';
import BusinessIcon from '@material-ui/icons/Business';

export default {
  edit: HandbookEditView,
  icon: BusinessIcon,
};
